import { CommonUtil } from './commonUtil';

/**
 * bem helper
 * b() // 'button'
 * b('text') // 'button__text'
 * b({ disabled }) // 'button button--disabled'
 * b('text', { disabled }) // 'button__text button__text--disabled'
 * b(['disabled', 'primary']) // 'button button--disabled button--primary'
 */

export type Mod = string | { [key: string]: any };
export type Mods = Mod | Mod[];
const namespace = 'wqms-'

export function createNamespace(name: string|string[]) {
    let names:string[] = <string[]>(CommonUtil.isString(name)? (name as string).split(' '): name )
    return names.map(i=> namespace+i).join(' ')
}

function gen(name: string, mods?: Mods): string {
  if (!mods) {
    return '';
  }

  if (typeof mods === 'string') {
    return ` ${name}--${mods}`;
  }

  if (Array.isArray(mods)) {
    return mods.reduce<string>((ret, item) => ret + gen(name, item), '');
  }

  return Object.keys(mods).reduce(
    (ret, key) => ret + (mods[key] ? gen(name, key) : ''),
    ''
  );
}

export function createBEM(name: string) {
    const block = 'wqms-'+name
  return function (el?: Mods, mods?: Mods): string {
    if (el && typeof el !== 'string') {
      mods = el;
      el = '';
    }

    el = el ? `${block}__${el}` : block;

    return `${el}${gen(el, mods)}`;
  };
}

export type BEM = ReturnType<typeof createBEM>;
